const Style = {
    stack: 'space-y-6',
    title: 'text-xl font-semibold text-text-primary',
    description: 'mt-1 text-sm text-text-secondary',
    body: 'space-y-6',
    identity: 'flex items-center gap-4 border-b border-border pb-5',
    name: 'truncate text-base font-semibold text-text-primary',
    email: 'truncate text-sm text-text-secondary',
};

export default Style;
